<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="guia-de-estilo-2021" stroke="none" stroke-width="1" :fill="color" fill-rule="nonzero">
      <g
        id="06-Iconos-"
        transform="translate(-906.000000, -610.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="Group-4" transform="translate(142.000000, 610.000000)">
          <g id="Icon/icn_chevrons-left" transform="translate(764.000000, 0.000000)">
            <path
              d="M13.7238576,8.39052429 C14.2445567,7.86982524 15.0887767,7.86982524 15.6094757,8.39052429 C16.1301748,8.91122335 16.1301748,9.75544332 15.6094757,10.2761424 L15.6094757,10.2761424 L9.88561808,16 L15.6094757,21.7238576 C16.1301748,22.2445567 16.1301748,23.0887767 15.6094757,23.6094757 C15.0887767,24.1301748 14.2445567,24.1301748 13.7238576,23.6094757 L13.7238576,23.6094757 L7.05719096,16.942809 C6.5364919,16.42211 6.5364919,15.57789 7.05719096,15.057191 L7.05719096,15.057191 Z M23.057191,8.39052429 C23.57789,7.86982524 24.42211,7.86982524 24.942809,8.39052429 C25.4635081,8.91122335 25.4635081,9.75544332 24.942809,10.2761424 L24.942809,10.2761424 L19.2189514,16 L24.942809,21.7238576 C25.4635081,22.2445567 25.4635081,23.0887767 24.942809,23.6094757 C24.42211,24.1301748 23.57789,24.1301748 23.057191,23.6094757 L23.057191,23.6094757 L16.3905243,16.942809 C15.8698252,16.42211 15.8698252,15.57789 16.3905243,15.057191 L16.3905243,15.057191 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconChevronsLeft extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconChevronsLeft;
</script>
